import classNames from 'classnames/bind';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from './index.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import Checkbox from '@/components/ui/kit/Checkbox';
import { FieldText } from '@/components/ui/kit/Field';
import Select from '@/components/ui/kit/Select';
import { CAMERAS } from '@/define/camera';
import OlMap from '@/helpers/OlMap';

const cx = classNames.bind(styles);

const PhotosOverlay = ({ robotId }) => {
  const dispatch = useDispatch();
  const robotOptions = useSelector((state) => state.robotOptions[robotId]);

  const toggleVisible = (key) => {
    dispatch(actions.robotOptions.toggleVisible(robotId, key));
  };

  const changeOverlayType = (e) => {
    dispatch(actions.robotOptions.changePhotoType(robotId, e.target.value));
  };

  const changeCamera = (e) => {
    dispatch(actions.robotOptions.changeCamera(robotId, e.target.value));
  };

  const changeFocalLength = (e) => {
    dispatch(actions.robotOptions.changeFocalLength(robotId, e.target.value));
  };

  const resetOverlay = () => {
    OlMap.removePhotos(robotId);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('title')}>Photos Overlay</div>
      <div className={cx('box')}>
        <FieldRow label="Show Overlay" height={24}>
          <Checkbox checked={robotOptions.photo.visible} onClick={() => toggleVisible('photo')} />
        </FieldRow>
        <FieldRow label="Overlay Type">
          <Select
            value={robotOptions.photo.type}
            onChange={changeOverlayType}
            disabled={!robotOptions.photo.visible}
            className={cx('select')}>
            <option value="marker">Marker</option>
            <option value="footprint" disabled>
              Footprint
            </option>
          </Select>
        </FieldRow>
        {robotOptions.photo.type === 'footprint' && (
          <>
            <FieldRow label="Camera">
              <Select
                value={robotOptions.photo.camera.name}
                onChange={changeCamera}
                disabled={!robotOptions.photo.visible}
                className={cx('select')}>
                {CAMERAS.map((camera, index) => (
                  <option key={index} value={camera.name}>
                    {camera.name}
                  </option>
                ))}
              </Select>
            </FieldRow>
            <FieldRow label="Focal Length" unit="㎜">
              <Select
                value={robotOptions.photo.focalLength}
                onChange={changeFocalLength}
                disabled={!robotOptions.photo.visible}
                className={cx('select')}>
                {robotOptions.photo.camera.specs.focalLengths.map((focalLength, index) => (
                  <option key={index} value={focalLength}>
                    {focalLength}
                  </option>
                ))}
              </Select>
            </FieldRow>
            <FieldRow label="Sensor Size" unit="㎜">
              <FieldText
                value={`${robotOptions.photo.camera.specs.sensorSize.width} x ${robotOptions.photo.camera.specs.sensorSize.height}`}
                readOnly
                disabled={!robotOptions.photo.visible}
                className={cx('field')}
              />
            </FieldRow>
          </>
        )}
        <FieldRow label="Reset Overlay">
          <button type="button" className={cx('button')} onClick={resetOverlay}>
            Reset
          </button>
        </FieldRow>
      </div>
    </div>
  );
};

export default PhotosOverlay;
